export type Bonus = {
  number: string
  title: string
  /** Short title printed on the code-drawn cover. */
  short: string
  body: string
  /** Spine colour of the code-drawn cover. */
  accent: string
  /** Icon on the code-drawn cover. */
  icon: 'search' | 'helpers' | 'sign' | 'book' | 'timer'
  /** Optional rendered cover (square works best). When empty, a code-drawn cover is shown. */
  cover?: string
}

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'The Situation Finder: Any Practice Problem, the Right Page in 10 Seconds',
    short: 'The Situation Finder',
    body: 'An index of the whole pack by the situation you’re in, not by volume. “It’s raining and I have 40 kids.” “My throws coach is out.” “We compete tomorrow.” About 60 situations, each one pointing to the exact volume, page and session.',
    accent: 'bg-hl',
    icon: 'search',
    cover: 'https://cdn.magicpatterns.com/uploads/q7vYiDAZtQLSzBiyoUmPv3/mockup-the-situation-finder.png',
  },
  {
    number: '02',
    title: 'Volunteer Helper Briefing Cards',
    short: 'Volunteer Helper Briefing Cards',
    body: 'One-page cards to hand a parent or a brand-new assistant: what to watch, what to say, when to call you and what they never do. One card per low-risk station, plus the “Never Alone” rule for throws, hurdles and high jump.',
    accent: 'bg-clay',
    icon: 'helpers',
    cover: 'https://cdn.magicpatterns.com/uploads/jyxdJcM4FA5zeaWx9xYHw1/mockup-volunteer-helper-briefing-cards.png',
  },
  {
    number: '03',
    title: 'The Fence Station Sign Kit: Print, Post, and Every Group Knows Where to Go',
    short: 'The Fence Station Sign Kit',
    body: 'Everything to set up the Fence Card System in 15 minutes: group signs in the pack colours, station numbers, a card holder for the fence, throwing-area safety signs and a one-page setup checklist.',
    accent: 'bg-infield',
    icon: 'sign',
    cover: 'https://cdn.magicpatterns.com/uploads/3sprj79kaKR4eb4qRiW5Mr/mockup-the-fence-station-sign-kit.png',
  },
  {
    number: '04',
    title: 'Track Talk: The First-Year Coach’s Glossary',
    short: 'Track Talk',
    body: 'Heats, flights, seeding, scratch, PR, splits, foul, check mark, exchange zone, FAT… about 120 event and meet terms explained in one line each, plus a one-page “what is each event” table.',
    accent: 'bg-amber',
    icon: 'book',
    cover: 'https://cdn.magicpatterns.com/uploads/5RVDkfDtEJuMaxELAhENFM/mockup-track-talk.png',
  },
  {
    number: '05',
    title: 'Stopwatch and Tape: Time and Measure Without Electronic Timing',
    short: 'Stopwatch and Tape',
    body: 'Hand timing that’s consistent: when to start the watch, how to time 8 athletes with one stopwatch, how to take splits, and how to measure jumps and throws at practice. Plus 6 common errors and a group split sheet.',
    accent: 'bg-lane',
    icon: 'timer',
    cover: 'https://cdn.magicpatterns.com/uploads/xdkc2uxGeuZzUduKQcPhXi/mockup-stopwatch-and-tape.png',
  },
]
